export default __webpack_public_path__ + "static/media/DropdownOpener.cac107c6.svg";